export const VERSION = "1.3.4";


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 130
// module chunks = 14